// extracted by mini-css-extract-plugin
export default {"signalSelect":"LinePlot_signalSelect__7o5X+"};